import {useEffect,type ReactNode} from "react";
import {captureChatReferral} from '@/lib/chat-referral';
import { PublicLayout } from "./PublicLayout";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";

export function AuthShell({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: ReactNode;
}) {
  useEffect(()=>{captureChatReferral();},[]);
  return (
    <PublicLayout>
      <Card className="w-full">
        <CardHeader className="space-y-2">
          <h1 className="text-2xl font-semibold leading-none tracking-tight">{title}</h1>
          <CardDescription className="leading-6">{description}</CardDescription>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </PublicLayout>
  );
}
